import React from 'react';
import Welcome from './EducatePanels/Welcome';
import AboutWhatDataED3NCollects from './EducatePanels/AboutWhatDataED3NCollects';

const educateComponents = {
  welcome: <Welcome />,
  aboutWhatDataED3NCollects: <AboutWhatDataED3NCollects />,
  // Add other mappings here, import the components as needed
  // these keys should match those in educateMenu in index.js
  // aboutMissionStatement: <AboutMissionStatement />,
};

export default educateComponents;